import { CreateWarehouse } from './CreateWarehouse.main';

export { CreateWarehouse };
